<template>
  <div style="display: flex; flex-direction: row; justify-content: center; height: 100%; width: 100%; align-items: stretch">
    <!-- 聊天框 -->
    <div :class="{ big_chat_box: showWorkBench === false, small_chat_box: showWorkBench === true }">
      <ChatBox @renderWorkbenchData="renderWorkbenchData" @restoreWorkbenchData="restoreWorkbenchData" @updateConversationHistory="updateConversationHistory" @conversationIdResolved="updateConversationHistory" @closeWorkbench="closeWorkbench" :conversation_id="conversation_id" :tool_idx="tool_idx" :toolList="tool_list" :is_restored="is_restored" />
    </div>

    <!-- 工作台 -->
    <div class="workbench_panel" v-show="showWorkBench">
      <WorkBench :workbench_type="workbench_type" :workbench_content="workbench_content" @clossWorkBench="clossWorkBench" style="width: 100%; height: 100%" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import WorkBench_ArticelList from '../components/WorkBench_ArticelList.vue';
import ChatBox from "../components/ChatBox.vue";
import WorkBench from "../components/WorkBench.vue";
export default {
  name: "Conversation",
  components: {
    ChatBox,
    WorkBench,
  },
  props: {
    conversation_id: {
      // type: Object,
      required: true,
    },
    tool_idx: {
      // type: Object,
      required: true,
    },
    tool_list: {
      // type: Object,
      required: true,
    },
    // 透传给 ChatBox：这个会话是从 URL 上的会话 id 恢复出来的
    is_restored: {
      type: Boolean,
      default: false,
    },
    // conversation_data: {
    //   // type: Object,
    //   required: true,
    //   // default: () => ({'type': null, 'content': null})
    //   // // 可以添加更具体的验证
    //   // validator: (value) => {
    //   //   return 'type' in value && 'content' in value
    //   // }
    // }
  },
  data() {
    return {
      // type: workbenchData['type'],
      // content: workbenchData['ceontent'],

      // 工作台的渲染数据
      workbench_type: null,
      workbench_content: null,
      // 是否展示工作台
      showWorkBench: false,
    };
  },
  // computed: {
  //   type() {
  //   },
  //   content() {
  //   }
  // },
  // computed: {
  //   // 解析文献列表数据
  //   articleList() {
  //     try {
  //       // 如果content是JSON字符串则解析，否则直接使用
  //         ? JSON.parse(this.workbenchData.content)
  //         : this.workbenchData.content;
  //     } catch (error) {
  //       console.error('解析文献数据失败:', error);
  //     }
  //   }
  // },
  // mounted() {
  //   // // 修复：初始化折叠状态（超过200字符的摘要默认折叠）
  //   // this.isCollapsed = this.articleList.map(
  //   //   article => article.description.length > 200
  //   // );
  // },
  // activated() {
  //   console.log('页面显示了');
  // },
  // created() {
  // },
  methods: {
    closeWorkbench() {
      this.showWorkBench = false;
    },
    // 历史回显恢复工作台：确保打开，不做 toggle。
    restoreWorkbenchData(data, idx) {
      this.workbench_type = data.type;
      this.workbench_content = data.content;
      this.workbench_idx = idx;
      this.showWorkBench = true;
    },
    // // 传递子组件调用给爷爷组件的关闭方法
    // clossWorkBench() {
    //   this.$emit('clossWorkBench')
    // }
    // 接收ChatBox的组件传递给WorkBench
    renderWorkbenchData(data, idx) {
      // // console.log(this._uid)
      // // alert(111)
      // // alert(data)
      // // console.log(data.type)
      // // console.log(data.content)
      // // console.log('2222222')
      // // data = typeof(data === 'string') ? JSON.parse(data) : data
      // 同一个按钮点击就展示或者隐藏
      if (this.workbench_idx == idx) this.showWorkBench = !this.showWorkBench;
      // 不同按钮点击就只展示
      else this.showWorkBench = true;

      this.workbench_type = data.type;
      this.workbench_content = data.content;
      this.workbench_idx = idx;
    },
    // 关闭工作台
    clossWorkBench() {
      this.showWorkBench = false;
    },
    // 更新会话历史
    updateConversationHistory() {
      this.$emit("updateConversationHistory");
    },
  },
};
</script>

<style scoped>
.big_chat_box {
  width: 100%;
  /* margin: 20px; */
}

.small_chat_box {
  flex: 0 0 56%;
  width: 56%;
  min-width: 620px;
  /* margin: 20px; */
}
.workbench_panel {
  flex: 0 0 44%;
  width: 44%;
  min-width: 520px;
  height: 100%;
  margin-left: 10px;
  z-index: 996;
}
</style>
